module.exports = __webpack_public_path__ + "static/media/DefensiveCoding.e278c42e.jpg";